'use client';

import { cn } from '@/lib/utils';

export default function GlassCard({ children, className }) {
  return (
    <div
      className={cn(
        'rounded-2xl border border-border/50 bg-card/80 p-6 shadow-lg backdrop-blur-xl sm:p-8',
        'dark:bg-card/60 dark:shadow-[0_0_20px_rgba(79,209,229,0.04)]',
        className
      )}
    >
      {children}
    </div>
  );
}
